"use strict";

exports.__esModule = true;
exports.DeviceDataItemStatsSelector = DeviceDataItemStatsSelector;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.dataItemName;
}
function renderItemText(input) {
  return input.dataItemName;
}
function renderItemLabel(input) {
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceDataItemStatsSelector.itemLabel",
    defaultMessage: "{deviceCount, number} {deviceCount, plural, one {device} other {devices}}",
    values: input
  });
}
function itemPredicate(query, stats) {
  var q = query.toLowerCase();
  return stats.dataItemName.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select device data item(s) by name from a list
 * of device data item stats.
 * Stats are of the form:
 * <pre><code>
 *   {dataItemName: "XAbs", deviceCount: 10}
 * </code></pre>
 */
function DeviceDataItemStatsSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: props.multiple ? translate("DeviceDataItemStatsSelector.placeholder.multiple", "Select Data Items") : translate("DeviceDataItemStatsSelector.placeholder.single", "Select Data Item"),
      getKey: getKey,
      renderItemText: renderItemText,
      renderItemLabel: renderItemLabel,
      itemPredicate: itemPredicate,
      width: 275
    }, props));
  });
}